import { selectPropsSchema } from '../component-catalog.js';
export const selectDefinition = {
    type: 'Select',
    category: 'interactive',
    propsSchema: selectPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Dropdown selector with discrete options. Props: options (required, array of { label, value }), selected?, placeholder?.',
};
//# sourceMappingURL=Select.js.map